var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sessions"},[(!_vm.isInApp)?_c('hero'):_vm._e(),_c('trending-sessions',{attrs:{"sessions":_vm.sessions,"loading":_vm.loading,"bookMarks":_vm.bookMarks,"followedBloggers":_vm.followedBloggers},on:{"bookMarkBlog":_vm.handleToggleShelfSessions}}),_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }